module.exports = __webpack_public_path__ + "static/media/sun.2d4d2a5d.svg";